export enum ProjectVariableType {
  Normal,
  DateTimeManual,
  DateTimeFileCreated,
  DateTimeFileSaved,
  DateTimeProjectSaved,
  DateTime
}
